const THEME_NAME_SEPARATOR = "_";
const THEME_CLASSNAME_PREFIX = "t_";
const webOnlyDefaultStyles = {
  display: "flex",
  flexBasis: "auto",
  boxSizing: "border-box",
  position: "relative",
  minHeight: 0,
  minWidth: 0
};
const stackDefaultStyles = {
  alignItems: "stretch",
  flexShrink: 0,
  ...webOnlyDefaultStyles
};
export {
  THEME_CLASSNAME_PREFIX,
  THEME_NAME_SEPARATOR,
  stackDefaultStyles,
  webOnlyDefaultStyles
};
//# sourceMappingURL=constants.js.map
